import * as types from '../../../../constants/ActionNameConstants';

const initialState = {
  loading: false,
  user: [],
  error: null,
};

const CheckForceUnclaimReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHECK_FORCE_UNCLAIM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.CHECK_FORCE_UNCLAIM_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case types.CHECK_FORCE_UNCLAIM_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.CHECK_FORCE_UNCLAIM_RESET: // Add this case to handle reset
      return {
        ...state,
        loading: false,
        user: [], // Reset the user data to its initial state
      };
    default:
      return state;
  }
};

export default CheckForceUnclaimReducer;
